// Test IDs for Aerial Alignment marketing site
export const AA = {
  // Nav
  navLogo: "nav-logo",
  navHome: "nav-home",
  navServices: "nav-services",
  navDrone: "nav-drone",
  navQuote: "nav-quote",
  navContact: "nav-contact",
  navCtaQuote: "nav-cta-quote",

  // Hero
  heroCtaQuote: "hero-cta-quote",
  heroCtaServices: "hero-cta-services",

  // Services accordion
  serviceAccordion: "service-accordion",
  serviceItem: (key) => `service-item-${key}`,

  // Drone capabilities
  droneCard: (key) => `drone-card-${key}`,

  // Quote generator
  quoteServiceSelect: "quote-service-select",
  quoteAddressInput: "quote-address-input",
  quoteEstimateBtn: "quote-estimate-btn",
  quoteResult: "quote-result",
  quoteRequestBtn: "quote-request-btn",
  quoteForm: {
    name: "quote-form-name",
    email: "quote-form-email",
    phone: "quote-form-phone",
    company: "quote-form-company",
    details: "quote-form-details",
    submit: "quote-form-submit",
  },
  quoteSuccess: "quote-success",

  // Contact
  contactForm: {
    name: "contact-name",
    email: "contact-email",
    phone: "contact-phone",
    message: "contact-message",
    submit: "contact-submit",
    success: "contact-success",
  },

  // Coverage map
  coverageMap: "coverage-map",

  // Footer
  footerPhone: "footer-phone",
  footerEmail: "footer-email",
};
